import { User } from 'types/user'
const esc = encodeURIComponent

interface IReportType {
    parameter: string
    locations?: string
    sectors?: string
    reporterSector?: string
    startDate?: string
    finalDate?: string
    damageLevel?: string
    incidentType?: string
    omsClassification?: string
    bringArchived?: boolean
    sectorActive?: string
}

export const ROUTES_NAMES = {
    location: {
        get: {
            // omitido ou 'all' = todas | true = u_notifica=true | false = u_notifica=false
            all: (uNotifica?: boolean | 'all') =>
                uNotifica === undefined
                    ? `/proxy/location.get.all`
                    : `/proxy/location.get.all|${uNotifica}`,
            byid: (id: string) => `/proxy/location.get.byid|${id}`,
            by_sector_id_paginate: (
                sectorId: string,
                offset?: string,
                limit?: string,
                order?: any,
                locationId?: string
            ) =>
                `/proxy/location.get.by_sector_id_paginate|${sectorId},${
                    offset ? `${parseInt(offset) * parseInt(limit)}` : '0'
                },${limit ? limit : process.env.REACT_APP_MAX_ITENS_TABLE},${
                    order ? `${order.order}${order.field}` : ''
                },${locationId ? locationId : ''}`,
            by_sector_id_paginate_v2: (
                sectorId: string,
                offset?: string,
                limit?: string,
                order?: any,
                locationId?: string
            ) =>
                `/resource/location/get_locations_by_sector_id_paginate|${sectorId},${
                    offset ? `${parseInt(offset) * parseInt(limit)}` : '0'
                },${limit ? limit : process.env.REACT_APP_MAX_ITENS_TABLE},${
                    order ? `${order.order}${order.field}` : ''
                },${locationId ? locationId : ''}`,
            all_paginate: (
                offset?: string,
                limit?: string,
                order?: any,
                search?: string,
                locationId?: string
            ) => {
                let str = `/resource/location/all_paginate|${
                    offset ? `${parseInt(offset) * parseInt(limit)}` : '0'
                },${limit ? limit : process.env.REACT_APP_MAX_ITENS_TABLE}${
                    order ? `,${order.order}${order.field}` : ''
                },${search ? `${search}` : ''},${
                    locationId ? `${locationId}` : ''
                }`
                return str
            }
        },
        post: {
            update_sector_location_status: `/proxy/location.post.update_sector_location_status`
        }
    },
    sector: {
        get: {
            all_paginate: (
                offset?: string,
                limit?: string,
                order?: any,
                search?: string,
                locationId?: string
            ) => {
                let str = `/resource/sector/all_paginate|${
                    offset ? `${parseInt(offset) * parseInt(limit)}` : '0'
                },${limit ? limit : process.env.REACT_APP_MAX_ITENS_TABLE}${
                    order ? `,${order.order}${order.field}` : ''
                },${search ? `${search}` : ''},${
                    locationId ? `${locationId}` : ''
                }`
                return str
            },
            count: `/proxy/sector.get.count`,
            all: `/proxy/sector.get.all`,
            byid: (id: string) => `/proxy/sector.get.byid|${id}`,
            by_locationid: (
                locationId: string,
                search?: string,
                status?: string,
                order?: any
            ) =>
                `/proxy/sector.get.by_locationid_new|${locationId},${search},${status}${
                    order ? `,${order.order}${order.field}` : ''
                }`,
            full_by_locationid: (locationId: string) =>
                `/resource/sector/by_locationid|${locationId}`,
            grouped_by_locationid: () =>
                `/resource/sector/grouped_by_locationid`,
            get_all_by_destination_sector: (destinationSectorId: string) =>
                `/resource/sector/get_all_by_destination_sector|${destinationSectorId}`
        },
        post: {
            create: `/proxy/sector.post.create`
        },
        put: {
            update: (sys_id: string) => `/proxy/sector.put.update|${sys_id}`,
            update_all_notification_and_sectors: (
                sys_id: string,
                locationId?: string
            ) =>
                `/resource/sector/update_all_notification_and_sectors|${sys_id}${
                    locationId ? `,${locationId}` : ''
                }`
        }
    },
    user: {
        get: {
            by_attribute_value: (attribute: string, value: string) =>
                `/proxy/user.get.by_attribute_value|${attribute},${value}`,
            all_active: `/proxy/user.get.all_active`,
            all: `/proxy/user.get.all`,
            all_paginate_v2: (
                offset?: string,
                limit?: string,
                user?: User,
                order?: any
            ) =>
                `/resource/user/all_paginate|${
                    offset ? `${parseInt(offset) * parseInt(limit)}` : '0'
                },${limit ? limit : process.env.REACT_APP_MAX_ITENS_TABLE}${
                    user
                        ? `,${Object.keys(user)
                              .map(
                                  (attrUser: string) =>
                                      `${esc(attrUser)}${
                                          attrUser === 'u_user'
                                              ? 'STARTSWITH'
                                              : '%3D'
                                      }${esc(
                                          user[attrUser as keyof typeof user]
                                      )}`
                              )
                              .join('%5E')}`
                        : ','
                }${order ? `,${order.order}${order.field}` : ''}`,
            all_paginate: (
                offset?: string,
                limit?: string,
                user?: User,
                order?: any
            ) =>
                `/proxy/user.get.all_paginate|${
                    offset ? `${parseInt(offset) * parseInt(limit)}` : '0'
                },${limit ? limit : process.env.REACT_APP_MAX_ITENS_TABLE}${
                    user
                        ? `,${Object.keys(user)
                              .map(
                                  (attrUser: string) =>
                                      `${esc(attrUser)}${
                                          attrUser === 'u_user'
                                              ? 'STARTSWITH'
                                              : '%3D'
                                      }${esc(
                                          user[attrUser as keyof typeof user]
                                      )}`
                              )
                              .join('%5E')}`
                        : ','
                }${order ? `,${order.order}${order.field}` : ''}`,
            byid: (id: string) => `/proxy/user.get.byid|${id}`,
            byidResource: (id: string) => `/resource/user/byid|${id}`,
            byAttribute: (attribute: string, value: string) =>
                `/proxy/user.get.by_attribute_value|${attribute},${value}`,
            count: (user?: User) =>
                `/proxy/user.get.count${
                    user
                        ? `|${Object.keys(user)
                              .map(
                                  (attrUser: string) =>
                                      `${esc(attrUser)}%3D${esc(
                                          user[attrUser as keyof typeof user]
                                      )}`
                              )
                              .join('%5E')}`
                        : ''
                }`,
            by_location_id_and_profile: (locationId: string, profile: string) =>
                `/proxy/user.get.by_location_id_and_profile|${locationId},${profile}`,
            by_filter: (user: User) =>
                `/proxy/user.get.by_filter${
                    user
                        ? `|${Object.keys(user)
                              .map(
                                  (attrUser: string) =>
                                      `${esc(attrUser)}%3D${esc(
                                          user[attrUser as keyof typeof user]
                                      )}`
                              )
                              .join('%5E')}`
                        : ''
                }`,
            sys_user: (sys_user: string) =>
                `/proxy/user.get.sys_user|${sys_user}`,
            by_saaccount_name: (saAccountName: string) =>
                `/resource/user/by_saaccount_name|${saAccountName}`,
            download_all_users_with_locations_and_sectors: (user?: User) =>
                `/resource/user/download_all_users_with_locations_and_sectors|${
                    user
                        ? `${Object.keys(user)
                              .map((attrUser: string) => {
                                  return `${esc(attrUser)}%3D${esc(
                                      user[attrUser as keyof typeof user]
                                  )}`
                              })
                              .join('%5E')}`
                        : ''
                }`,
            paginated_users_with_locations_and_sectors: (
                offset?: string,
                limit?: string,
                user?: User,
                order?: any
            ) =>
                `/resource/user/paginated_users_with_locations_and_sectors|${
                    offset ? `${parseInt(offset) * parseInt(limit)}` : '0'
                },${limit ? limit : process.env.REACT_APP_MAX_ITENS_TABLE}${
                    user
                        ? `,${Object.keys(user)
                              .map((attrUser: string) => {
                                  // Se for filtro STARTSWITH, não coloca igual
                                  if (attrUser.includes('STARTSWITH')) {
                                      return esc(attrUser)
                                  }
                                  // Para os demais, coloca igual
                                  return `${esc(attrUser)}%3D${esc(
                                      user[attrUser as keyof typeof user]
                                  )}`
                              })
                              .join('%5E')}`
                        : ','
                }${order ? `,${order.order}${order.field}` : ''}`
        },
        post: {
            create: `/proxy/user.post.create`,
            createWithMultiLocations: `/resource/user/create`
        },
        put: {
            update: (sys_id: string) => `/proxy/user.put.update|${sys_id}`,
            updateResource: (sys_id: string) =>
                `/resource/user/update|${sys_id}`
        }
    },
    variables: {
        get: {
            all: `/proxy/variables.get.all`
        }
    },
    notification: {
        get: {
            all: `/proxy/notification.get.all`,
            all_to_download: (
                location: string,
                sectors?: string,
                initialDate?: string,
                finalDate?: string
            ) =>
                `/report/notification/download_csv|${location},${
                    sectors ? `${sectors}` : `null`
                },${initialDate},${finalDate}`,
            all_to_download_base64: (
                location: string,
                sectors?: string,
                initialDate?: string,
                finalDate?: string
            ) =>
                `/resource/notification/download_base64|${location},${
                    sectors ? `${sectors}` : `null`
                },${initialDate},${finalDate}`,
            count_by_location: `/proxy/notification.get.count_by_location`,
            count: `/proxy/notification.get.count`,
            all_paginate: ({
                offset,
                limit,
                state,
                location,
                sectors,
                search,
                orderby
            }: {
                offset?: string
                limit?: string
                state?: number
                location?: string
                sectors?: string
                search?: string
                orderby?: string
            }) =>
                `/proxy/notification.get.all_paginate|${
                    offset ? `${parseInt(offset) * parseInt(limit)}` : '0'
                },${limit ? limit : process.env.REACT_APP_MAX_ITENS_TABLE},${
                    state ? `${state}` : `null`
                },${location ? `${location}` : `null`},${
                    sectors ? `${sectors}` : `null`
                },${search ? `${search}` : `null`},${
                    orderby ? `${orderby}` : `null`
                }`,
            byid: (id: string) => `/proxy/notification.get.byid|${id}`,
            byNotificationid: (id: string) =>
                `/resource/notification/byid|${id}`,
            byStatus: (status: number) =>
                `/proxy/notification.get.status|${status}`,
            render: (location?: string, sectors?: string, search?: string) =>
                `/resource/notification/notification_manager_screen${
                    location || sectors || search
                        ? `|${location ? `${location}` : `null`},${
                              sectors ? `${sectors}` : `null`
                          },${search ? `${search}` : `null`}`
                        : ``
                }`,
            count_by_state: `/proxy/notification.get.count_by_state`,
            ishikawa_by_notificationid: (id: string) =>
                `/resource/notification/ishikawa_by_notificationid|${id}`,
            accountability_matrix_by_notificationid: (id: string) =>
                `/proxy/notification.get.accountability_matrix_by_notificationid|${id}`,
            london_protocol_by_notificationid: (id: string) =>
                `/proxy/notification.get.london_protocol_by_notificationid|${id}`,
            all_user_notification_statistics: `/resource/notification/all_user_notification_statistics`,
            damage_level: `/resource/notification/damage_level`,
            types_of_diagnosis: `/proxy/notification.get.types_of_diagnosis`,
            sentinel_event: `/proxy/notification.get.sentinel_event`,
            never_events: `/resource/notification/never_events`,
            notification_factors: `/proxy/notification.get.factors`,
            notification_london_varibles: `/proxy/variables.get.london_protocol`,
            planAction: (notificationId: string) =>
                `/proxy/notification.get.plan_action_by_notificationid|${notificationId}`,
            //all_notifications_paginate: ({ offset, limit, state, location, sectors, search, orderby }: { offset?: string, limit?: string, state?: number, location?: string, sectors?: string, search?: string, orderby?: string }) => `/resource/notification/list_all_notifications|${offset ? `${parseInt(offset) * parseInt(limit)}` : '0'},${limit ? limit : process.env.REACT_APP_MAX_ITENS_TABLE},${state ? `${state}` : `null`},${location ? `${location}` : `null`},${sectors ? `${sectors}` : `null`},${search ? `${search}` : `null`},${orderby ? `${orderby}` : `null`}`,
            presignedUrl: (url: string) =>
                `/resource/notification/presignedUrl|${url}`,
            count_last_reclassified_incident_type: `/resource/notification/count_last_reclassified_incident_type`,
            count_last_reclassified_incident_type_by_location_id: (
                location_id: string
            ) =>
                `/resource/notification/count_last_reclassified_incident_type_by_location_id|${location_id}`,
            all_notifications_paginate: ({
                offset,
                limit,
                state,
                location,
                sectors,
                search,
                damageLevel,
                order,
                orderby,
                subState,
                uUserType
            }: {
                offset?: string
                limit?: string
                state?: number
                location?: string
                sectors?: string
                search?: string
                damageLevel?: string
                order?: string
                orderby?: string
                subState?: string
                uUserType?: string | null
            }) =>
                `/resource/notification/list_all_notifications|${
                    offset ? `${parseInt(offset) * parseInt(limit)}` : '0'
                },${limit ? limit : process.env.REACT_APP_MAX_ITENS_TABLE},${
                    state ? `${state}` : `null`
                },${location ? `${location}` : `null`},${
                    sectors ? `${sectors}` : `null`
                },${search ? `${search}` : `null`},${
                    damageLevel ? `${damageLevel}` : `null`
                },${order ? `${order}` : `null`},${
                    orderby ? `${orderby}` : `null`
                },${subState ? `${subState}` : `null`
                },${uUserType ? `${uUserType}` : `null`
                }`,
            presigned_url_by_id: (id: string) =>
                `/resource/notification/presigned_url_by_id|${id}`,
            count_by_sector: (sectorId: string) =>
                `/proxy/notification.get.count_by_sector|${sectorId}`,
            byGroupId: (groupId: string) =>
                `/resource/notification/by_group_key|${groupId}`,
            byIds: (ids: string) =>
                `/resource/notification/byids|${ids}`
        },
        put: {
            update: (sys_id: string) =>
                `/proxy/notification.put.update|${sys_id}`,
            update_bulk: `/resource/notification/update_bulk`,
            update_ishikawa: '/resource/notification/update_ishikawa',
            update_london_protocol: (id: string) =>
                `/proxy/notification.put.update_london_protocol|${id}`,
            update_accountability_matrix: (id: string) =>
                `/proxy/notification.put.update_accountability_matrix|${id}`,
            updatePlanAction: (id: string) =>
                `/proxy/notification.put.update_plan_action|${id}`,
            create_s3_file: `/resource/notification/create_s3_file`,
            delete_s3_file: `/resource/notification/delete_s3_file`,
            update_accountability_matrix_batch: '/resource/notification/update_accountability_matrix_batch',
            update_london_protocol_batch: '/resource/notification/update_london_protocol_batch',
            update_action_plan_batch: '/resource/notification/update_plan_action',
        },
        post: {
            create: '/proxy/notification.post.create',
            create_by_patient: '/resource/notification/create_by_patient',
            create_ishikawa: '/resource/notification/create_ishikawa',
            create_london_protocol:
                '/proxy/notification.post.create_london_protocol',
            create_accountability_matrix: `/proxy/notification.post.create_accountability_matrix`,
            attach: '/proxy/notification.post.attach',
            createPlan: '/proxy/notification.post.create_plan_action',
            create_action_plan: '/resource/notification/create_plan_action',
            create_london_protocol_batch: '/resource/notification/create_london_protocol_batch',
            create_accountability_matrix_batch: '/resource/notification/create_accountability_matrix_batch',
            calculate_accountability_matrix: `/resource/notification/calculate_accountability_matrix`
        },
        delete: {
            deletePlanAction: (actionId: string) =>
                `/proxy/notification.delete.plan_action_by_id|${actionId}`,
            delete_accountability_matrix: (id: string) =>
                `/proxy/notification.delete.delete_accountability_matrix|${id}`,
            delete_file_upload: (id: string) =>
                `/proxy/notification.delete.delete_file_upload|${id}`,
            remove_from_treatment_group: () => `/resource/notification/remove_from_treatment_group`,
            delete_action_plan_batch: '/resource/notification/delete_plan_action',
        }
    },
    treatment_groups: {
        post: {
            create: '/resource/treatment_groups/create'
        }
    },
    report: {
        get: {
            notification_count_grouping_by_any: ({
                parameter,
                locations,
                reporterSector,
                startDate,
                finalDate,
                damageLevel,
                incidentType,
                omsClassification,
                bringArchived,
                sectorActive
            }: IReportType) =>
                `/proxy/report.get.notification_count_grouping_by_any|${parameter},${locations},${reporterSector},${startDate},${finalDate},${damageLevel},${incidentType},${omsClassification},${bringArchived}, ${sectorActive}`,
            auto_notification: ({
                parameter,
                locations,
                reporterSector,
                startDate,
                finalDate,
                damageLevel,
                incidentType,
                omsClassification
            }: IReportType) =>
                `/resource/report/auto_notification|${parameter},${locations},${reporterSector},${startDate},${finalDate},${damageLevel},${incidentType},${omsClassification},true`,
            avg_date: ({
                parameter,
                locations,
                reporterSector,
                startDate,
                finalDate,
                damageLevel,
                incidentType,
                omsClassification
            }: IReportType) =>
                `/resource/report/avg_time|${parameter},${locations},${reporterSector},${startDate},${finalDate},${damageLevel},${incidentType},${omsClassification},true`
        },
        post: {
            notification_count_grouping_by_any: `/resource/report/notification_count_grouping_by_any`,
            notification_count_grouping_by_date: `/resource/report/notification_count_grouping_by_date`,
            auto_notification: `/resource/report/auto_notification`,
            avg_date: `/resource/report/avg_time`,
            download_excel: `/resource/report/download_excel`
        }
    }
}
